<template>
  <div class="item-overflow-actions">
    <v-menu
      v-if="validItemActions"
      tile
      left
      offset-y
      allow-overflow
      offset-overflow
      close-on-click
    >
      <template #activator="{ on, attrs }">
        <v-btn
          class="item-overflow-actions--three-dot-btn"
          :data-cy="(item.borrowerTaskName || item.name || item.nickname) + '-3-dot-btn'"
          icon
          v-bind="attrs"
          v-on="on"
          @click="handleThreeDotClick(item)"
        >
          <v-icon>$snMenuDotsHorizontalSolid</v-icon>
        </v-btn>
      </template>

      <v-list
        v-if="showActions"
        class="item-overflow-actions--item-list overflow-y-auto"
      >
        <div
          v-for="action in validItemActions"
          :key="action.key"
          :data-cy="`${action.text ? action.text.toLowerCase().replace(/\s/g, '-') : 'row'}-action`"
        >
          <v-list-item
            v-if="!action.subActions"
            link
            @click="handleItemClick(action, item)"
          >
            <v-list-item-icon v-if="action.icon">
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              {{ action.text }}
            </v-list-item-title>
          </v-list-item>

          <v-menu
            v-else
            v-model="showSubActions"
            tile
            left
            offset-x
            allow-overflow
            offset-overflow
            close-on-click
          >
            <template #activator="{on}">
              <v-list-item
                :active="showSubActions"
                v-on="on"
                @click.stop="handleItemClick(action, item)"
              >
                <v-list-item-icon v-if="action.icon">
                  <v-icon>{{ action.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-title
                  style="margin-right: 32px"
                >
                  {{ action.text }}
                </v-list-item-title>

                <v-icon
                  size="18"
                >
                  sn-icon-chevron-right
                </v-icon>
              </v-list-item>
            </template>

            <v-list class="item-overflow-actions--item-list overflow-y-auto">
              <div
                v-for="subAction in validSubActions(action)"
                :key="subAction.key"
              >
                <v-list-item
                  :data-cy="`${subAction.text ? subAction.text.toLowerCase().replace(/\s/g, '-') : 'row'}-sub-action`"
                  link
                  @click="handleSubItemClick(action, subAction, item)"
                >
                  <v-list-item-icon v-if="subAction.icon">
                    <v-icon>{{ subAction.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title>
                    {{ subAction.text }}
                  </v-list-item-title>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>

          <v-divider v-if="action.divider" />
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'ItemActionsThreeDotMenu',
  mixins: [clickaway],
  props: {
    item: {
      type: Object,
      required: true
    },
    itemActions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showSubActions: false,
      showActions: false
    }
  },
  computed: {
    validItemActions () {
      return this.itemActions?.filter(a => a.conditional === undefined || a.conditional(this.item)) ?? this.itemActions
    }
  },
  methods: {
    handleItemClick (action, item) {
      if (action.subActions) {
        this.showSubActions = true
      } else {
        this.$emit('item-action', {
          action: action.name,
          selectedItems: [item]
        })
      }
    },
    handleSubItemClick (action, subAction, item) {
      this.showActions = false
      this.$emit('item-sub-action', {
        action: action.name,
        subAction: subAction.name,
        selectedItems: [item]
      })
    },
    handleThreeDotClick (item) {
      this.showActions = true
      this.$emit('three-dot-click', item)
    },
    validSubActions (action) {
      return action.subActions.filter(a => a.conditional === undefined || a.conditional(this.item)) ?? action.subActions
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.v-menu__content {
  border-radius: 4px !important;
  box-shadow: $sn-shadow-depth-3;

  .v-list-item:focus:before,
  .v-list-item:hover:before {
    opacity: 0 !important;
  }
  .v-list-item:hover,
  .v-list-item[active] {
    background-color: $sn-brand-01;
  }

  .v-list-item:focus {
    background-color: $sn-brand-02;
  }

  .v-list-item {
    font-family: $font-family-primary;

    & .v-list-item__title, .v-list-item__icon {
      color: $sn-primary-03;
    }
  }

  .v-list-item__icon:first-child {
    margin-right: 8px;
  }
}

.item-overflow-actions {
  &--three-dot-btn {
    &:hover, &:focus {
      color: $sn-brand;
    }
  }

  &--item-list {
    max-height: 500px;
  }
}
</style>
